import React from 'react';
import SlideLayout, { SlideTitle, SlideContent } from '../components/SlideLayout';
import { Star, CheckCircle } from 'lucide-react';

const takeaways = [
  {
    number: 1,
    title: 'Reasoning ≠ Just Scaling',
    description: 'Emerged from RL on verifiable tasks (RLVR), not just bigger models',
    color: 'primary'
  },
  {
    number: 2,
    title: 'GRPO Enables Training',
    description: 'Simpler than PPO, more stable for language models',
    color: 'secondary'
  },
  {
    number: 3,
    title: 'Chain-of-Thought is Crucial',
    description: 'Transparent reasoning improves accuracy and trust',
    color: 'accent'
  },
  {
    number: 4,
    title: 'Inference Compute Trade-offs',
    description: 'More compute = better answers (but higher cost/latency)',
    color: 'chart-4'
  },
  {
    number: 5,
    title: 'Real NOC Applications',
    description: 'Diagnosis, config generation, capacity planning',
    color: 'chart-5'
  },
  {
    number: 6,
    title: 'Humans Still Needed',
    description: 'Models are co-pilots, not full autopilots',
    color: 'chart-1'
  },
];

const KeyTakeawaysSlide = () => {
  return (
    <SlideLayout maxWidth="6xl">
      <SlideTitle 
        subtitle="Remember these key points from today's lecture"
      >
        Key Takeaways
      </SlideTitle>
      
      <SlideContent>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {takeaways.map((takeaway, index) => (
            <div 
              key={index}
              className={`slide-card hover:border-${takeaway.color}/50 transition-all group`}
            >
              <div className="flex items-start gap-3">
                <div className={`w-8 h-8 rounded-lg bg-${takeaway.color}/20 flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform`}>
                  <span className={`font-mono font-bold text-${takeaway.color}`}>{takeaway.number}</span>
                </div>
                <div>
                  <p className="font-heading font-semibold text-foreground">{takeaway.title}</p>
                  <p className="text-sm text-muted-foreground mt-1">{takeaway.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {/* Summary quote */}
        <div className="mt-8 p-6 rounded-xl bg-gradient-to-r from-primary/10 via-secondary/10 to-accent/10 border border-primary/20">
          <div className="flex items-start gap-4">
            <Star className="w-6 h-6 text-primary flex-shrink-0" />
            <div>
              <p className="text-lg text-foreground">
                "Reasoning models represent a fundamental shift in AI capabilities — 
                from pattern matching to systematic problem-solving."
              </p>
              <p className="text-sm text-muted-foreground mt-2">
                The key is knowing when and how to apply them effectively.
              </p>
            </div>
          </div>
        </div>
      </SlideContent>
    </SlideLayout>
  );
};

export default KeyTakeawaysSlide;
